import React, { useState, useEffect } from "react";
import ScoreChart from "./Charts/ScoreChart";
import Select from "react-select";
import score from "../../../assets/images/score.svg";
import Back from "../../../Back";
import { ScoreIcon } from "../../../SvgIconsData";
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import HorizontalTimeline from "./HorizontalTimeline";
import { medalXL } from "../../../utils/useWindowDimensions";

const TraitsDetail = () => {
  const userData = useSelector((state) => state.userSlice);

  var uuid = userData?.user?.uuid;

  const [loading, setLoading] = useState(true);

  const [currentRange, setCurrentRange] = useState("week");

  const { id } = useParams();

  const [options,setoptions]=useState([]);

  const defaultlabel = options[id-1];

  const [selectedOption, setSelectedOption] = useState(defaultlabel);

  const [insights, setinsights] = useState({});

  const configData = useSelector((state) => state.configSlice);

  const navigate = useNavigate();

  const handleSelectChange = (e) => {
    setSelectedOption(e);
    navigate(`/traits/insights/${e.value}/${uuid}`);
  };

  const fetchinsightsData = async () => {
  
    if (id=="undefined") {
      console.error('Invalid id or uuid');
      return;
    }
    try {
      const response = await axios.get(
        `${configData?.config?.apiBaseUrl}/api/fetchtraitsdata/${id}/${uuid}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token || " "}`,
          },
        }
      );
      setinsights(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching insights data:', error.response);
    }
  };
  
  const fetchAllTraitsOptions=async()=>{
    try {
      const allTraitsOptions = await (await axios.get(
        `${configData?.config?.apiBaseUrl}/api/fetchAllTraitsData`,
        {
          headers: {
            Authorization: `Bearer ${userData.token || " "}`,
          },
        }
      ))?.data?.data?.map((trait)=>{
        return {
          value:trait?.id,
          label:trait?.name
        }
      });
      setoptions(()=>allTraitsOptions)
      const index =allTraitsOptions.findIndex((e) => e.value == id);
      setSelectedOption(allTraitsOptions[index]);
      fetchinsightsData();
    } catch (error) {
      console.error('Error fetching insights data:', error.response);
    }
  }

  useEffect(() => {
    fetchAllTraitsOptions()
  }, [id]);

  const renderInterpretation = (item, index) => {
    switch (item.type) {
      case "accordian":
        return (
          <div class="accordion-item" key={index}>
            <h2 class="accordion-header">
              <button
                class="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse-${index}`}
                aria-expanded="false">
                {item.title}
              </button>
            </h2>
            <div
              id={`collapse-${index}`}
              class={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
              data-bs-parent="#accordionFlushExample">
              <div
                class="accordion-body color-light font-xss"
                dangerouslySetInnerHTML={{ __html: item.text }}></div>
            </div>
          </div>
        );
      case "heading":
        return (
          <div className="p-3 border round-2 mb-4">
            <p
              className="mb-0 font-xss color-light line-height-2"
              dangerouslySetInnerHTML={{ __html: item.text }}></p>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <div className="container-fluid p-4">
        <div className="row justify-content-between pb-3">
          <div className="col-md-3">
            <div className="d-flex gap-2 align-items-center">
              <Back />{" "}
              <Select
                className="custom-select"
                value={selectedOption}
                options={options}
                onChange={handleSelectChange}
              />
            </div>
          </div>
          <div className="col-md-4">
            <ul className="FilterDataRange">
              <li
                className={currentRange === "all" ? "active" : ""}
                onClick={() => setCurrentRange("all")}>
                All
              </li>
              <li
                className={currentRange === "week" ? "active" : ""}
                onClick={() => setCurrentRange("week")}>
                W
              </li>
              <li
                className={currentRange === "month" ? "active" : ""}
                onClick={() => setCurrentRange("month")}>
                M
              </li>
              <li
                className={currentRange === "half-year" ? "active" : ""}
                onClick={() => setCurrentRange("half-year")}>
                6M
              </li>
              <li
                className={currentRange === "year" ? "active" : ""}
                onClick={() => setCurrentRange("year")}>
                Y
              </li>
            </ul>
          </div>
        </div>
        <div className="insights">
          <div className="row">
            <div className="col-md-8">
              <div className="position-sticky top-0">
                <div className="card bg-light-blue position-relative mb-4 min-height-120 overflow-hidden">
                  <div className="card-body">
                    <div className="introcard d-flex gap-3 align-items-center">
                      <div className="logo">
                        {/* <img className="rounded-2" src={userData?.user?.avatar} alt="" /> */}
                        {userData?.user?.avatar ? (
                          <img className="rounded-2" src={userData.user.avatar} alt="" />
                        ) : (
                          <div className="avatar-placeholder">
                            {userData.user.name &&
                              userData.user.name
                                .split(" ")
                                .slice(0, 2)
                                .map((word) => word[0])
                                .join("")
                                .toUpperCase()}
                          </div>
                        )}
                      </div>
                      <div>
                        <h5 className="mb-1">{userData?.user?.name}</h5>
                        <p className="font-xs mb-0">{userData?.user?.designation}</p>
                        <p className="font-xs mb-0">{userData?.user?.group.name}</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6 mb-4">
                    <div className="card h-100">
                      <div className="card-body bg-light-yellow text-center">
                        <div className="datacount align-items-start">
                          <span className="bg-warning overflow-hidden">
                            <ScoreIcon />
                          </span>
                          <div>
                            <div className="text-warning-dark pb-2 pt-2">
                              <p className="m-0 line-height1 font-xss">Avg Score</p>
                              <h2 className="m-0">
                                <strong>{insights?.medianScore}</strong>
                              </h2>
                            </div>
                            <div className="text-warning pt-2">
                              <p className="m-0 line-height1 font-xss">Highest Score</p>
                              <h4 className="m-0">
                                <strong>{insights?.usermaxScore}</strong>
                              </h4>
                            </div>
                          </div>
                        </div>
                      </div>
                      <img
                        src={score}
                        className="dashimg"
                        style={{ width: "80px", opacity: ".2" }}
                        alt=""
                      />
                    </div>
                  </div>
                  <div className="col-md-6 mb-4">
                    <div className="card bg-light-yellodark  h-100">
                      <div className="card-body">
                        <div className="datacount">
                          <span className="bg-warningdark position-relative statusderfv">
                            {medalXL[insights.interpretation?.result]}
                          </span>
                          <div style={{ color: "#f58729" }}>
                            <p className="m-0 line-height1">Skill Level</p>
                            <h4 className="m-0">
                              <strong>{insights.interpretation?.result}</strong>
                            </h4>
                          </div>
                        </div>
                        <HorizontalTimeline activeStage={insights.interpretation?.result} />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="card mb-4">
                  <div className="card-body">
                    <h6 className="mb-0">
                      Score Chart{" "}
                      <span className="font-xss color-light">Tracks your score across time</span>
                    </h6>
                    <ScoreChart currentRange={currentRange} />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className={`card mb-4 min-height-120 overflow-hidden ${insights?.trait?.color}`}>
                <div className="card-body">
                  <h5>{insights?.trait?.name}</h5>
                  <p className="font-xss color-light m-0 gamedetaildf">
                    {insights?.trait?.description}
                  </p>
                </div>
              </div>
              <div className="card">
                <div className="card-body">
                  <h5 className="mb-2">Interpretation</h5>
                  <div class="accordion accordion-flush mt-3" id="accordionFlushExample">
                    {insights?.interpretation?.data?.map((item, index) => {
                      return renderInterpretation(item, index);
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default TraitsDetail;
